import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'

export default {
  props: {
    title: String,
    serviceOrderId: Number,
    machineDowntime: Object,
    disabled: Boolean,
  },

  created() {
    if (this.machineDowntime) {
      this.currentMachineDowntime = this.machineDowntime
      this.stoppedDateTime = this.machineDowntime.dateTimeMachineStopped
      this.returnDateTime = this.machineDowntime.dateTimeMachineReturn
      this.isEditing = true
    }
  },

  data: () => ({
    step: 0,
    errorMessage: '',
    isEditing: false,
    loading: false,
    firstValid: false,
    error: false,
    dialog: false,
    stoppedDateTimeError: false,
    stoppedDateTime: null,
    returnDateTime: null,
    currentMachineDowntime: {
      id: 0,
      dateTimeMachineStopped: null,
      dateTimeMachineReturn: null,
    },
    apiService: new ApiService(),
  }),

  computed: {
    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    close() {
      this.$emit('close')
    },

    async next() {
      if (this.step == 1) this.$emit('close')

      if (this.step === 0) {
        if (this.$refs.firstForm.validate() && this.stoppedDateTime) {
          this.submit()
        } else {
          this.stoppedDateTimeError = true
        }
      } else {
        this.close()
      }
    },

    setStoppedNowDate() {
      this.stoppedDateTime = !this.stoppedDateTime
        ? new Date()
        : this.stoppedDateTime
    },

    setReturnNowDate() {
      this.returnDateTime = !this.returnDateTime
        ? new Date()
        : this.returnDateTime
    },

    async submit() {
      this.loading = true

      const machineDowntime = {
        Id: this.currentMachineDowntime.id,
        DateTimeMachineStopped: Utils.nowDatetimeFormat(this.stoppedDateTime),
        DateTimeMachineReturn: Utils.nowDatetimeFormat(this.returnDateTime),
        ServiceOrderId: this.serviceOrderId,
      }

      let url = 'machineDowntime/add'

      if (this.isEditing) {
        url = 'machineDowntime/edit'
      }

      await this.apiService
        .post(url, machineDowntime)
        .then(() => {
          this.step++
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
    },

    formatDateTime(date) {
      return Utils.dateTime(date)
    },

    parseDate(date) {
      if (!date) return null

      const dateTimeSplit = date.split(' ')

      const [day, month, year] = dateTimeSplit[0].split('/')
      const time = dateTimeSplit[1]

      if (time) {
        return `${year}-${month.padStart(2, '0')}-${day.padStart(
          2,
          '0'
        )} ${time}:00`
      }

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatInitialDate(dateInitial) {
      const date = new Date(dateInitial),
        day = date.getDate().toString(),
        dayF = day.length == 1 ? '0' + day : day,
        month = (date.getMonth() + 1).toString(),
        monthF = month.length == 1 ? '0' + month : month,
        yearF = date.getFullYear()
      return `${dayF}-${monthF}-${yearF}`
    },
  },

  watch: {
    stoppedDateTime: {
      deep: true,
      handler() {
        this.stoppedDateTimeError = false
      },
    },
  },
}
